/**
 * Whether a published `LifeDocument` actually has something to show
 * (DESIGN.md §7's second empty state: "published but not yet substantive").
 * The fixture's `fixture-placeholder` model publishes a real document with
 * every projection field null/"unknown" — functionally the same "nothing
 * here yet" experience as `life() === null`, so `OrganismScreen` uses this
 * to decide whether the Life panel should default to a slim collapsed strip
 * instead of a full-height table of dashes.
 */

import type { LifeDocument } from "../types/incremental";

export function isLifeSubstantive(life: LifeDocument | null): boolean {
  if (!life) return false;
  const p = life.projection;
  return (
    p.median_cycles !== null ||
    p.p10_cycles !== null ||
    p.p90_cycles !== null ||
    p.dominant_hazard !== "unknown"
  );
}
